import ReactDOM from 'react-dom';
import React from 'react';
import { Store } from 'redux';
import { Provider } from 'react-redux';
import './index.css';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import App from './App';
import reportWebVitals from './reportWebVitals';
// eslint-disable-next-line import/no-unresolved
import './tailwind.output.css';
import './utils/i18n';
import configureStore, { IAppState } from './store';

// import { getSimpleComponentData } from './actions/dashboardAction';

interface IProps {
  store: Store<IAppState>;
}

const emotionCache = createCache({
  key: 'css',
  prepend: true,
});
/*
Create a root component that receives the store via props
and wraps the App component with Provider, giving props to containers
*/
const Root: React.FC<IProps> = (props) => {
  const { store } = props;
  return (
    <React.StrictMode>
      <Provider store={store}>
        <CacheProvider value={emotionCache}>
          <App selectedLanguage="en" />
        </CacheProvider>
      </Provider>
    </React.StrictMode>
  );
};
// Generate the store
const reduxStore = configureStore();

document.body.style.fontVariant = 'none';

ReactDOM.render(
  <Root store={reduxStore} />,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
